import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";

export default function FieldFormula_Popover(props:any) {
    return (
        <Popover popoverClass="gd-field-formula-edit-popover"
                 className="gd-field-formula-edit-popover-container"
                 position={PopoverPosition.bottomCenter()}
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            {props.field.getFormulaWithValues(props.model)}

        </Popover>
    )
}
